import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Deshabilita la actualización automática al enfocar la ventana
      retry: 2, // Número de reintentos en caso de fallo
    },
  },
});